<div class="modern-login-container">
  <div class="login-wrapper">
    <!-- Sol Taraf - Gradient Arka Plan -->
    <div class="login-left-panel">
      <div class="welcome-content">
        <h1 class="welcome-title">{{ 'Login.WelcomeTitle' | translate }}</h1>
        <p class="welcome-subtitle">{{ 'Login.WelcomeSubtitle' | translate }}</p>
        <div class="feature-list">
          <div class="feature-item">
            <i class="fa fa-check-circle"></i>
            <span>{{ 'Login.Feature1' | translate }}</span>
          </div>
          <div class="feature-item">
            <i class="fa fa-check-circle"></i>
            <span>{{ 'Login.Feature2' | translate }}</span>
          </div>
          <div class="feature-item">
            <i class="fa fa-check-circle"></i>
            <span>{{ 'Login.Feature3' | translate }}</span>
          </div>
        </div>
      </div>
    </div>

    <!-- Sağ Taraf - Login Form -->
    <div class="login-right-panel">
      <div class="login-card-modern">
        <!-- Language Selector Dropdown -->
        <div class="language-dropdown-wrapper">
          <div class="translate_wrapper" [class.active]="showLanguageDropdown">
            <div class="current_lang" (click)="toggleLanguageDropdown()">
              <div class="lang">
                <i class="flag-icon flag-icon-{{selectedLanguage.icon}}"></i>
                <span class="lang-txt">{{selectedLanguage.code | uppercase}}</span>
                <i class="fa fa-chevron-down ms-1"></i>
              </div>
            </div>
            <div class="more_lang" [class.active]="showLanguageDropdown">
              <div class="lang" (click)="changeLanguage('fr')">
                <i class="flag-icon flag-icon-fr"></i>
                <span class="lang-txt">Français</span>
              </div>
              <div class="lang" (click)="changeLanguage('tr')">
                <i class="flag-icon flag-icon-tr"></i>
                <span class="lang-txt">Türkçe</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Logo -->
        <div class="logo-section">
          <a class="logo" routerLink="/">
            <img
              width="120"
              height="120"
              class="img-fluid"
              src="https://monassist.com/img/monLogoMiddle.png"
              alt="MonAssist Logo"
            />
          </a>
        </div>

        <!-- Login Form -->
        <div class="login-form-section">
          <form class="modern-form" [formGroup]="loginForm">
            <div class="form-header">
              <h4 class="form-title">{{ 'Login.SignIn' | translate }}</h4>
              <p class="form-subtitle">{{ 'Login.EnterCredentials' | translate }}</p>
            </div>

            <!-- Username Field -->
            <div class="form-group-modern">
              <label class="form-label-modern">
                <i class="fa fa-user"></i>
                {{ 'Login.Username' | translate }}
              </label>
              <input
                class="form-control modern-input"
                type="text"
                [(ngModel)]="user"
                required=""
                [placeholder]="'Login.UsernamePlaceholder' | translate"
                formControlName="userName"
              />
              <div
                *ngIf="
                  loginForm.controls.userName.touched &&
                  loginForm.controls.userName.errors?.required
                "
                class="error-message"
              >
                <i class="fa fa-exclamation-circle"></i>
                {{ 'Login.UsernameRequired' | translate }}
              </div>
              <div
                *ngIf="
                  loginForm.controls.userName.touched &&
                  loginForm.controls.userName.errors?.userName
                "
                class="error-message"
              >
                <i class="fa fa-exclamation-circle"></i>
                {{ 'Login.InvalidUsername' | translate }}
              </div>
            </div>

            <!-- Password Field -->
            <div class="form-group-modern">
              <label class="form-label-modern">
                <i class="fa fa-lock"></i>
                {{ 'Login.Password' | translate }}
              </label>
              <div class="password-input-wrapper">
                <input
                  class="form-control modern-input"
                  [(ngModel)]="password"
                  [type]="show ? 'text' : 'password'"
                  formControlName="password"
                  required=""
                  [placeholder]="'Login.PasswordPlaceholder' | translate"
                />
                <div class="password-toggle" (click)="showPassword()">
                  <app-feather-icons [icon]="show ? 'eye-off' : 'eye'"></app-feather-icons>
                </div>
              </div>
              <div
                *ngIf="
                  loginForm.controls.password.touched &&
                  loginForm.controls.password.errors?.required
                "
                class="error-message"
              >
                <i class="fa fa-exclamation-circle"></i>
                {{ 'Login.PasswordRequired' | translate }}
              </div>
            </div>

            <!-- Captcha Section -->
            <div class="form-group-modern">
              <label class="form-label-modern">
                <i class="fa fa-shield"></i>
                {{ 'Login.SecurityVerification' | translate }}
              </label>
              <div class="captcha-container">
                <div class="captcha-image-wrapper">
                  <img
                    src="{{ captchaData }}"
                    class="captcha-image"
                    alt="Captcha"
                  />
                  <button 
                    class="btn-refresh-modern" 
                    type="button"
                    (click)="captcha()"
                  >
                    <app-feather-icons [icon]="'refresh-cw'"></app-feather-icons>
                  </button>
                </div>
                <input
                  class="form-control modern-input"
                  type="text"
                  required=""
                  [placeholder]="'Login.SecurityCodePlaceholder' | translate"
                  formControlName="recaptcha"
                  [(ngModel)]="getCode"
                />
              </div>
            </div>

            <!-- Remember Me & Forgot Password -->
            <div class="form-options">
              <div class="remember-me">
                <!-- Optional: Add remember me checkbox -->
              </div>
              <a 
                [routerLink]="'/authentication/forgot-password'" 
                class="forgot-link"
              >
                <i class="fa fa-question-circle"></i>
                {{ 'Login.ForgotPassword' | translate }}
              </a>
            </div>

            <!-- Submit Button -->
            <div class="form-actions">
              <button
                class="btn-primary-modern w-100"
                [disabled]="!loginForm.valid"
                (click)="login()"
                type="button"
              >
                <i class="fa fa-sign-in"></i>
                <span>{{ 'Login.SignInButton' | translate }}</span>
              </button>
            </div>

            <!-- Optional: Sign up link -->
            <!-- <div class="form-footer">
              <span class="text-muted">{{ 'Login.NoAccount' | translate }}</span>
              <a href="#" class="signup-link">{{ 'Login.CreateAccount' | translate }}</a>
            </div> -->
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
